import styled, { keyframes } from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { GoArrowLeft } from 'react-icons/go';

// Rotation animation for loader
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const StyledSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--Shades-0, #fff);
  padding: 40px;

  ${media.md`
    padding: 40px;
  `}

  ${media.lg`
    padding: 60px;
  `}
`;

export const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;

export const LoaderImage = styled.img`
  width: 100%;
  height: 100%;
  animation: ${rotate} 2s linear infinite;
  ${media.md`
    width: 80%;
  height: 80%;
  `}
`;

export const StoreButtonsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;

  ${media.md`
    flex-direction: row;
    justify-content: center;
    gap: 20px;
  `}
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  max-width: 600px;
  text-align: center;

  ${media.md`
    gap: 40px;
  `}
`;

export const Title = styled.h2`
  color: var(--Shades-900, #1c1c1c);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-size: ${props => (props.locale === 'ru' ? '42px' : '46px')};
  font-style: normal;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: 85%;
  letter-spacing: -0.7px;
  text-transform: uppercase;
  margin: 0;

  ${media.md`
    font-size: ${props => (props.locale === 'ru' ? '58px' : '66px')};
    letter-spacing: -1.1px;
  `}

  ${media.lg`
    font-size: ${props => (props.locale === 'ru' ? '66px' : '74px')};
    letter-spacing: -1.3px;
  `}
`;

export const Subtitle = styled.p`
  color: var(--Shades-700, #67656e);
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.36px;
  margin: 0;

  ${media.md`
    font-size: 22px;
  `}

  ${media.lg`
    font-size: 24px;
  `}
`;

export const QRWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  p {
    color: var(--Shades-700, #67656e);
    font-family: 'Satoshi Variable Medium', sans-serif;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
  }
`;

export const QRCode = styled.div`
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;

  ${media.md`
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 20px;
  `}
`;

export const DownloadButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #ff9500;
  border-radius: 116px;
  padding: 16px 32px;
  height: 56px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 110%;
  margin: 0;
  border: none;
  text-align: center;
  cursor: pointer;
  transition: background 0.3s ease;

  &:active {
    transform: translateY(1px);
  }

  ${media.md`
    font-size: 20px;
    max-width: 390px;
  `}
`;

export const StoreButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56px;
  border-radius: 12px;
  border: 2px solid #1c1c1c;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    transform: translateY(1px);
  }

  ${media.md`
    max-width: 180px;
  `}
`;

export const StoreIcon = styled.img`
  width: 140px;
  height: 26px;
  flex-shrink: 0;

  ${media.md`
    width: 120px;
    height: 22px;
  `}
`;

export const MobileButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 56px);
  background: #ff9500;
  border-radius: 116.162px;
  padding: 14px 28px;
  gap: 9.293px;
  height: 30px;
  color: #1c1c1c;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 110%;
  margin: 0px;
  text-align: center;
  cursor: pointer;

  position: relative;
  overflow: hidden;
  z-index: 1;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #ff7c18;
  }

  .ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple-animation 1.5s ease-out;
    background-color: rgba(204, 85, 0, 0.6);
    pointer-events: none;
  }

  @keyframes ripple-animation {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }

  ${media.md`
    display:none;
  `}
`;

export const StyledButton = styled.a`
  display: none;
  ${media.md`
    display: flex;
    padding: 14px 27.879px;
    justify-content: center;
    align-items: center;
    gap: 9.293px;
    border-radius: 116.162px;
    background: var(--orange-500, #ff9500);
    justify-content: center;
    align-items: center;
    gap: 8px;
    color: var(--Grey-Scale-900, #1c1c1c);
    text-align: center;
    font-family: "Satoshi Variable Medium", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 110%;
    cursor:pointer;
    position: relative;
    overflow: hidden;
    z-index: 1;
    transition: background 0.3s ease, color 0.3s ease;
  
    &:hover {
      background: #ff7c18;
    }
  
    .ripple {
      position: absolute;
      border-radius: 50%;
      transform: scale(0);
      animation: ripple-animation 1.5s ease-out;
      background-color: rgba(204, 85, 0, 0.6);
      pointer-events: none;
      z-index: 0;
    }
  
    @keyframes ripple-animation {
      to {
        transform: scale(4);
        opacity: 0;
      }
    }
  `}
  ${media.lg`
    
  
  `}
  ${media.xl`
    
    
    padding: 14px 27.879px;
  `}
`;

export const StyledGoArrowLeft = styled(GoArrowLeft)`
  width: 15px;
  height: 15px;
  color: #fff;
  background: var(--Shades-900, #1c1c1c);
  border-radius: 50%;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${media.lg`
    width: 19px;
    height: 19px;
    padding: 10px;
  `}
`;
